"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var remote_1 = require("../../../remote");
var baseUrl = "https://storage.googleapis.com/icstorage/";
function Banners() {
    var _this = this;
    var _a = react_1.useState([]), banners = _a[0], setBanners = _a[1];
    react_1.useEffect(function () {
        var loadBanners = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, remote_1.getBanners()];
                    case 1:
                        res = _a.sent();
                        setBanners(res === null || res === void 0 ? void 0 : res.data);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        loadBanners();
    }, []);
    return (react_1.default.createElement("div", { id: "printribe-dashboard-banner", className: "carousel slide", "data-ride": "carousel" },
        (banners === null || banners === void 0 ? void 0 : banners.length) > 1 && (react_1.default.createElement("ol", { className: "carousel-indicators" }, banners.map(function (_, index) { return (react_1.default.createElement("li", { "data-target": "#printribe-dashboard-banner", "data-slide-to": index, className: index === 0 ? "active" : "", key: index })); }))),
        react_1.default.createElement("div", { className: "carousel-inner" }, banners === null || banners === void 0 ? void 0 : banners.map(function (banner, index) { return (react_1.default.createElement("div", { key: index, className: "carousel-item " + (index === 0 ? "active" : "") }, (banner === null || banner === void 0 ? void 0 : banner.banner) && (react_1.default.createElement("img", { src: "" + baseUrl + (banner === null || banner === void 0 ? void 0 : banner.banner), className: "d-block w-100", alt: banner === null || banner === void 0 ? void 0 : banner.altText })))); })),
        (banners === null || banners === void 0 ? void 0 : banners.length) > 1 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("button", { className: "carousel-control-prev border-0", type: "button", "data-target": "#printribe-dashboard-banner", "data-slide": "prev" },
                react_1.default.createElement("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }),
                react_1.default.createElement("span", { className: "sr-only" }, "Previous")),
            react_1.default.createElement("button", { className: "carousel-control-next border-0", type: "button", "data-target": "#printribe-dashboard-banner", "data-slide": "next" },
                react_1.default.createElement("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }),
                react_1.default.createElement("span", { className: "sr-only" }, "Next"))))));
}
exports.default = Banners;
